import React from "react";
import styled from "styled-components";
import { PanelCardSectionHeader } from "@sonder/ui/source/styled/fragments/PanelCardSectionHeader";

interface ChecklistProps {
  children?: React.ReactNode;
  title?: React.ReactNode;
}

export const StyledChecklist = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Checklist = ({ children, title }: ChecklistProps) => {
  return (
    <>
      <PanelCardSectionHeader>{title}</PanelCardSectionHeader>
      <StyledChecklist>{children}</StyledChecklist>
    </>
  );
};
